import { call } from 'redux-saga/effects';

import { getOrg } from '@api/user';

export const fetchUserOrganizationsSaga = function* (id) {
  const orgResponse = yield call(getOrg, id);
  return { orgs: orgResponse };
};
